module.exports = __webpack_public_path__ + "static/ssb-day2-7d58ac72cbe8d08a13377f79fea6e548.png";